/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOwnTimeOffContext} from '../api'

 export const useQueryGetOwnTimeOffContext = createReactQueryHook('getOwnTimeOffContext', getOwnTimeOffContext)
